import React from 'react';
import PropTypes from 'prop-types';

import TransactionTooltip from 'admin-moderator/components/TransactionTooltip';

import { ReactComponent as Ruble } from 'icons/Ruble.svg';
import { ReactComponent as Pay } from 'icons/Pay.svg';

import Price from 'styled/Price';

import Wrapper from './Wrapper';
import Row from './Row';
import Text from './Text';

const STATUSES = {
  accrualTextMaterial: {
    icon: <Ruble />,
    text: 'Начислено за текстовый материал',
    sign: '+',
  },
  accrualMediaMaterial: {
    icon: <Ruble />,
    text: 'Начислено за медиаматериал',
    sign: '+',
  },
  writeOffMediaMaterial: {
    icon: <Ruble />,
    text: 'Отклонение одобренного материала',
    sign: '',
  },
  created: {
    icon: <Ruble />,
    text: 'Запрос на вывод средств',
    sign: '',
    tooltip: true,
  },
  processing: {
    icon: <Pay />,
    text: 'Вывод средств одобрен',
    sign: '',
    tooltip: true,
  },
  rejected: {
    icon: <Pay />,
    text: 'Вывод средств отклонен',
    sign: '',
    tooltip: true,
    error: true,
  },
  finished: {
    icon: <Pay />,
    text: 'Оплата прошла успешно',
    sign: '',
    tooltip: true,
  },
  failed: {
    icon: <Pay />,
    text: 'Ошибка оплаты',
    sign: '',
    tooltip: true,
    error: true,
  },
  failed_by_notification: {
    icon: <Pay />,
    text: 'Ошибка оплаты',
    sign: '',
    tooltip: true,
    error: true,
  },
};

class PaymentRow extends React.PureComponent {
  get date() {
    return new Date(this.props.date * 1000).toLocaleString('ru-RU', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Europe/Moscow',
    });
  }

  get status() {
    if (this.props.amount < 0 && this.props.type === 'task_material_reward') {
      return 'writeOffMediaMaterial';
    }

    if (this.props.amount >= 0 && this.props.type === 'task_material_reward') {
      return 'accrualMediaMaterial';
    }

    if (this.props.type === 'reward') {
      return 'accrualTextMaterial';
    }

    return this.props.status;
  }

  render() {
    return (
      <Row>
        <div style={{ display: 'flex' }}>
          <div style={{ flex: '0 0 auto', width: '50px' }}>
            {STATUSES[this.status] ? STATUSES[this.status].icon : <Ruble />}
          </div>

          <div>
            {this.date}

            <Wrapper style={{ width: `${STATUSES[this.status].tooltip && '180px' }` }}>
              <Text error={STATUSES[this.status].error}>{STATUSES[this.status].text}</Text>

              {STATUSES[this.status].tooltip && (
                <div style={{ display: 'inline-block', marginLeft: '5px' }}>
                  <TransactionTooltip
                    isSmall
                    method={this.props.method}
                    methodInfo={this.props.methodInfo}
                  />
                </div>
              )}
            </Wrapper>

            <div style={{ marginTop: '8px' }}>
              {this.props.comment && (<Text>{this.props.comment}</Text>)}

              {this.props.status && this.props.status.indexOf('failed') !== -1 && (
                <React.Fragment>
                  {this.props.errorCode && (<Text>code: {this.props.errorCode}</Text>)}

                  <Text>id: {this.props.id}</Text>
                </React.Fragment>
              )}
            </div>
          </div>
        </div>

        <Price>
          {STATUSES[this.status].sign}

          {this.props.amount}
        </Price>
      </Row>
    );
  }
}

PaymentRow.propTypes = {
  id: PropTypes.string,
  type: PropTypes.oneOf(['withdraw', 'task_material_reward', 'reward']),
  status: PropTypes.oneOf(['created', 'rejected', 'processing', 'failed', 'finished']),
  date: PropTypes.number,
  comment: PropTypes.string,
  amount: PropTypes.string,
  method: PropTypes.oneOf(['card', 'phone', 'yandex_wallet']),
  methodInfo: PropTypes.string,
  errorCode: PropTypes.number,
};

PaymentRow.defaultProps = {
  id: '',
  type: 'task_material_reward',
  status: undefined,
  date: null,
  amount: '0',
  comment: '',
  method: 'card',
  methodInfo: '',
  errorCode: undefined,
};

export default PaymentRow;
